import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var modal = {
	selectors: {
		element: '[data-modal]',
		trigger: '[data-modal-trigger]',
		close: '[data-modal-close]',
	},
	init: function () {
		var self = this,
			$elements = $(self.selectors.elements);

		var $close = $(self.selectors.close),
			modal = document.querySelector('.modal__content');

		$(document.body).on('click', self.selectors.trigger, function (e) {
			e.preventDefault();

			var $this = $(this),
				id = $this.attr('data-modal-trigger'),
				$content = $('[data-modal-content="' + id + '"]');

			disableBodyScroll(modal);
			$(document.body).addClass('modal-opened');

			setTimeout(function () {
				$this.blur();
				$(document.body).focus();
			}, 100);

			return false;
		});

		$(self.selectors.element).on('click', self.selectors.close, function (e) {
			e.preventDefault();

			enableBodyScroll(modal);
			clearAllBodyScrollLocks();
			$(document.body).removeClass('modal-opened');

			return false;
		});
	},
};

export { modal };
